import { render, staticRenderFns } from "./pageHeaderCard.vue?vue&type=template&id=a643b092&scoped=true"
import script from "./pageHeaderCard.vue?vue&type=script&lang=js"
export * from "./pageHeaderCard.vue?vue&type=script&lang=js"
import style0 from "./pageHeaderCard.vue?vue&type=style&index=0&id=a643b092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a643b092",
  null
  
)

export default component.exports